import { Link } from 'react-router-dom';
import { BadgeCheck, Timer, ShieldCheck, HardHat } from 'lucide-react';
import { SITE } from '../lib/site';

const guarantees = [
  { icon: BadgeCheck, text: 'Garantía de 10 años por escrito' },
  { icon: Timer, text: 'Plazos en el contrato, penalizados por nosotros' },
  { icon: ShieldCheck, text: 'Seguro de responsabilidad civil en vigor' },
  { icon: HardHat, text: 'Equipos propios, sin subcontratación encadenada' },
];

const AboutSection = () => {
  return (
    <section id="nosotros" className="py-24 md:py-32 max-w-[1400px] mx-auto px-6">
      <div className="grid lg:grid-cols-[1fr_1.1fr] gap-14 lg:gap-20 items-center">
        {/* Foto real + caption */}
        <div className="reveal relative">
          <div className="rounded-[4px] overflow-hidden bg-paper-2 shadow-paper">
            <img
              src="/fotos-webp/56798.webp"
              alt="Equipo de obra de HGO Servicios trabajando en una reforma en Málaga"
              className="w-full h-full object-cover aspect-[4/5] max-h-[560px]"
              loading="lazy"
            />
          </div>
          {/* Tira de credencial */}
          <div className="absolute -bottom-5 left-5 right-5 md:left-8 md:right-auto bg-ink text-paper rounded-[4px] px-6 py-4 flex items-center gap-4 shadow-[0_20px_50px_-18px_rgba(22,19,15,0.5)]">
            <span className="stat-number text-3xl text-clay-light">15+</span>
            <span className="text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-paper/70 leading-relaxed">
              años construyendo<br />en Málaga
            </span>
          </div>
        </div>

        {/* Contenido */}
        <div>
          <div className="reveal">
            <p className="label">Quiénes somos</p>
            <h2 className="font-display font-black uppercase tracking-[-0.02em] text-section-title mt-5">
              De la obra a tu <em className="font-serifit normal-case font-normal text-clay">casa</em>, sin intermediarios
            </h2>
          </div>
          <div className="reveal mt-7 space-y-4 text-ink-soft leading-relaxed">
            <p>
              HGO Servicios nace en {SITE.founded} de la mano de <strong className="text-ink font-semibold">{SITE.founder}</strong>,
              oficial de obra de toda la vida. Desde entonces hemos entregado más de 150 proyectos
              entre Málaga capital y la Costa del Sol: reformas integrales, obra nueva,
              locales comerciales y mantenimiento de comunidades.
            </p>
            <p>
              Nuestra diferencia es simple: <strong className="text-ink font-semibold">ejecutamos con equipos propios</strong>.
              Sin cadenas de subcontratación que dilatan plazos ni esconden defectos.
              El que te visita es el que presupuesta, y el que presupuesta responde de la obra.
            </p>
          </div>

          <ul className="reveal mt-9 grid sm:grid-cols-2 gap-x-8 gap-y-5">
            {guarantees.map((g) => {
              const Icon = g.icon;
              return (
                <li key={g.text} className="flex items-start gap-3">
                  <Icon size={19} className="text-clay shrink-0 mt-0.5" />
                  <span className="text-sm font-medium text-ink">{g.text}</span>
                </li>
              );
            })}
          </ul>

          <div className="reveal mt-10 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8 pt-8 border-t border-line">
            <div>
              <p className="font-serifit text-2xl text-clay">Hugo Caballero</p>
              <p className="text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-ink-faint mt-1">Fundador · HGO Servicios</p>
            </div>
            <Link to="/nosotros" className="btn border border-ink text-ink">
              Conocer más
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
